'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { Tag } from '@/components/elementary/Tag';
import { Tooltip } from '@/components/elementary/Tooltip';
import { ChevronDown } from '@/components/icons/ChevronDown';
import { Info } from '@/components/icons/Info';
import { FeatureCell } from '@/components/page-builder/global/pricingV1/featureComparison/FeatureCell';
import { PlanCallToAction } from '@/components/page-builder/global/pricingV1/shared/PlanCallToAction';
import { getColsClassName } from '@/components/page-builder/global/pricingV1/utils/table-helper';
import Heading from '@/components/typography/Heading';
import { Paragraph } from '@/components/typography/Paragraph';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { PRICING_CTA_SECTIONS, pricingSections, STICKY_HEADER_FADE_DISTANCE, STICKY_HEADER_FADE_THRESHOLD } from '@/constants/pricing.constants';
import { usePricingFeatureTranslations } from '@/hooks/usePricingFeatureTranslations';
import { useScrollFadeOut } from '@/hooks/useScrollFadeOut';
import { cn } from '@/lib/styles';
import { PRICING_TEST_IDS } from '@/lib/test-ids';
export function FeatureComparisonTable(t0) {
  const $ = _c(55);
  const {
    data,
    currentTab,
    yearly,
    className
  } = t0;
  const t = useTranslations("Pricing");
  const tPlanFeature = usePricingFeatureTranslations();
  const tSections = useTranslations("FeatureComparisonTable");
  const stickyRef = useRef(null);
  const containerRef = useRef(null);
  const opacity = useScrollFadeOut(containerRef, STICKY_HEADER_FADE_THRESHOLD, STICKY_HEADER_FADE_DISTANCE);
  let plansData;
  let rowClassName;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== className || $[1] !== currentTab || $[2] !== data || $[3] !== opacity || $[4] !== t || $[5] !== yearly) {
    const gridColsClassName = currentTab ? "grid-cols-2" : getColsClassName(data?.length, {
      includeExtraColumn: true
    });
    rowClassName = cn("grid divide-x divide-neutral-700", gridColsClassName);
    let t10;
    if ($[17] !== currentTab || $[18] !== data) {
      t10 = currentTab ? data?.filter(item => item.title === currentTab) : data;
      $[17] = currentTab;
      $[18] = data;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    plansData = t10;
    t6 = containerRef;
    if ($[20] !== className) {
      t7 = cn("text-neutral-light-100", className);
      $[20] = className;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    if ($[22] !== opacity) {
      t8 = {
        opacity
      };
      $[22] = opacity;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t9 = PRICING_TEST_IDS.COMPARE_CONTENT;
    t2 = stickyRef;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = cn("hidden lg:block lg:sticky lg:top-(--site-header-offset-desktop) lg:z-2 bg-brand-black pt-5", "border-b border-b-neutral-light-100 transition-[border-color] duration-300");
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    t4 = yearly ? <div className={cn("hidden lg:grid bg-brand-black", gridColsClassName)}><div />{plansData?.map(item_0 => <div key={`${item_0?.id}-popular-header`} className={cn("p-2 grid place-items-center", item_0.mostPopular && "bg-neutral-light-100 text-brand-black rounded-t-lg lg:-ml-px lg:pl-px")}>{item_0.mostPopular ? <Paragraph fontSize="bodyBoldMedium" className="uppercase">{t("mostPopular")}</Paragraph> : null}</div>)}</div> : null;
    let t11;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div />;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    let t12;
    if ($[26] !== plansData) {
      t12 = plansData?.map(_temp);
      $[26] = plansData;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    t5 = <div className={cn("grid", gridColsClassName)}>{t11}{t12}</div>;
    t1 = cn("grid", gridColsClassName);
    $[0] = className;
    $[1] = currentTab;
    $[2] = data;
    $[3] = opacity;
    $[4] = t;
    $[5] = yearly;
    $[6] = plansData;
    $[7] = rowClassName;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    plansData = $[6];
    rowClassName = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t10;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div />;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== plansData) {
    t11 = plansData?.map(_temp2);
    $[29] = plansData;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t1 || $[32] !== t11) {
    t12 = <div className={t1}>{t10}{t11}</div>;
    $[31] = t1;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t2 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5) {
    t13 = <div ref={t2} className={t3}>{t4}{t5}{t12}</div>;
    $[34] = t12;
    $[35] = t2;
    $[36] = t3;
    $[37] = t4;
    $[38] = t5;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== plansData || $[41] !== rowClassName || $[42] !== tPlanFeature || $[43] !== tSections || $[44] !== yearly) {
    t14 = pricingSections.map(section => <Collapsible key={section.key} defaultOpen={true} className="grid data-[state=closed]:border-b data-[state=closed]:border-neutral-700"><CollapsibleTrigger className="group inline-flex items-center gap-2 cursor-pointer px-2 py-5 text-start min-w-0"><Heading tag="h3" fontSize="headingSmall" className="text-neutral-light-100 truncate">{tSections.rich(`${section.key}`, {
            mark: _temp3
          })}</Heading><ChevronDown className="size-5 ml-2 transition-transform duration-200 group-data-[state=open]:rotate-180" /></CollapsibleTrigger><CollapsibleContent className="border border-neutral-700 rounded-xl">{section.items.map(featureKey => <div key={`row-${section.key}-${featureKey}`} className={rowClassName}><div className={cn("px-4 py-5 flex justify-between items-center gap-1 text-neutral-light-100")}><div className="flex flex-col lg:flex-row gap-1 lg:items-center"><span className="lok-text-body-bold-medium">{tPlanFeature.richLabel(featureKey, {
                  mark: _temp4
                })}</span>{tPlanFeature.hasTag(featureKey) ? <Tag name={tPlanFeature.getTag(featureKey)} size="small" className="w-fit mr-1" variant="gray-500" /> : null}</div>{tPlanFeature.hasTooltip(featureKey) ? <Tooltip content={tPlanFeature.rawTooltip(featureKey)}><span><Info className="text-neutral-light-400 size-4 shrink-0" /></span></Tooltip> : null}</div>{plansData?.map(plan => <div key={`${section.key}-${plan?.id}-${featureKey}`} className={cn("grid place-items-center px-4 py-5 text-neutral-light-100", plan.mostPopular && "lg:bg-surface-featured")}><FeatureCell featureItem={plan?.features?.find(item_1 => item_1.feature?.key === featureKey)} yearly={yearly} defaultChecked={!!plan.allFeaturesIncluded} /></div>)}</div>)}</CollapsibleContent></Collapsible>);
    $[40] = plansData;
    $[41] = rowClassName;
    $[42] = tPlanFeature;
    $[43] = tSections;
    $[44] = yearly;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t14) {
    t15 = <div className="rounded-b-xl overflow-hidden min-w-0">{t14}</div>;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t13 || $[49] !== t15 || $[50] !== t6 || $[51] !== t7 || $[52] !== t8 || $[53] !== t9) {
    t16 = <div ref={t6} className={t7} style={t8} data-test-id={t9}>{t13}{t15}</div>;
    $[48] = t13;
    $[49] = t15;
    $[50] = t6;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  return t16;
}
function _temp4(chunks_0) {
  return <span className="text-gradient">{chunks_0}</span>;
}
function _temp3(chunks) {
  return <span className="text-gradient">{chunks}</span>;
}
function _temp2(t0) {
  const {
    id: id_0,
    button,
    mostPopular: mostPopular_0,
    title: title_0
  } = t0;
  return <PlanCallToAction key={`${id_0}-cta`} button={button} planTitle={title_0 ?? undefined} section={PRICING_CTA_SECTIONS.FEATURE_COMPARISON} className={cn("pb-4 lg:whitespace-nowrap", mostPopular_0 && "pl-4 pr-3.75 bg-surface-featured lg:-ml-px border-x")} />;
}
function _temp(t0) {
  const {
    id,
    mostPopular,
    title
  } = t0;
  return <div key={`${id}-titles`} className={cn("px-3.75 pt-7.5 lg:pt-5 pb-2.5 relative", mostPopular && "pl-4 pr-3.75 bg-surface-featured lg:-ml-px border-x border-neutral-light-100")}><Heading tag="h2" className="mx-auto text-neutral-light-100" fontSize="headingMedium">{title}</Heading></div>;
}